import uploadshomefeaturesHerobgimage556139670HomepageHeroMainBJpg from "$lib/data/generated/uploads/home/Features Hero/bgImage/55613967-0-Homepage-hero-main-b.jpg";
import uploadshomefeaturesHerofeature01ImagethomasMoore2Png from "$lib/data/generated/uploads/home/Features Hero/Feature 01 Image/Thomas-Moore2.png";

export const uploads = {
  "uploads/home/Features Hero/Feature 01 Image/Thomas-Moore2.png": uploadshomefeaturesHerofeature01ImagethomasMoore2Png,
  "uploads/home/Features Hero/bgImage/55613967-0-Homepage-hero-main-b.jpg": uploadshomefeaturesHerobgimage556139670HomepageHeroMainBJpg
};